export function GenworthCostDataMethodologySlideOutContent() {
  return (
    <div className="flex grow flex-col gap-4">
      <div>
        <h2 className="pb-2 text-lg font-semibold md:text-xl">Data Source</h2>
        <p className="text-sm md:text-base">
          Our baseline cost of care figures come from the CareScout Cost of Care survey, which
          provides detailed cost data for care settings across the United States. We map the ZIP
          code from your intake form to the corresponding area in this survey.
        </p>
      </div>

      <div>
        <h2 className="pb-2 text-lg font-semibold md:text-xl">Inflation to Present Day</h2>
        <p className="text-sm md:text-base">
          To account for rising healthcare expenses, these costs are adjusted to present-day values.
        </p>
      </div>
    </div>
  );
}
